export default __webpack_public_path__ + "static/media/NotoSerif-Italic.438182a5.eot";